import * as React from "react";
import CmsAccordion from "../../../../../Accordion/containers/Accordion/Accordion.js";
import CmsArticleCollection from "../../../../../ArticleCollection/containers/ArticleCollection/ArticleCollection.js";
import CmsBanner from "../../../../../Banner/containers/Banner/Banner.js";
import CmsBannerCollection from "../../../../../BannerCollection/containers/BannerCollection/BannerCollection.js";
import CmsCarousel from "../../../../../Carousel/containers/Carousel/Carousel.js";
import CmsCountdownTimerDocument from "../../../../../CountdownTimer/containers/CountdownTimer/CountdownTimerDocument.js";
import CmsIframe from "../../../../../Iframe/containers/Iframe/Iframe.js";
import CmsLinkList from "../../../../../LinkList/containers/LinkList/LinkList.js";
import CmsRecommendedProducts from "../../../../../RecommendedProducts/containers/RecommendedProducts/RecommendedProducts.js";
import CmsRichTextDocument from "../../../../../RichText/containers/RichText/RichTextDocument.js";
import CmsVideo from "../../../../../Video/containers/Video/Video.js";
import CmsWidget from "../../../../../Widget/containers/Widget/Widget.js";
import { useBrPageContext } from "../../../../../../context/context/context.js";
const blockMap = {
  accordion: CmsAccordion,
  articleCollection: CmsArticleCollection,
  banner: CmsBanner,
  bannerCollection: CmsBannerCollection,
  carousel: CmsCarousel,
  countdown: CmsCountdownTimerDocument,
  iFrame: CmsIframe,
  linkList: CmsLinkList,
  recommendedProducts: CmsRecommendedProducts,
  video: CmsVideo,
  widget: CmsWidget,
  richText: CmsRichTextDocument
};
const ContentBlock = ({ contentBlock }) => {
  const page = useBrPageContext();
  const component = mapBlockToComponent(contentBlock);
  const BlockComponent = getComponentForBlockType(contentBlock.type);
  const headingLevel = contentBlock.type === "accordion" ? "h2" : void 0;
  return BlockComponent && component ? /* @__PURE__ */ React.createElement(BlockComponent, { component, page, headingLevel }) : null;
};
function getComponentForBlockType(type) {
  const Component = blockMap[type];
  if (!Component) {
    console.log(`Missing Component for content block type: ${type}`);
    return;
  }
  return Component;
}
function mapBlockToComponent({
  anchorId,
  coverImage,
  document,
  expandedByDefault,
  recommendedProducts,
  html,
  template,
  videoUrl,
  visibility,
  source,
  showCountdown,
  endDate,
  countdownText,
  layout,
  height,
  scrolling,
  title,
  imageWidth,
  imageAlignment,
  bannerWidth,
  bannerHeight,
  tooltip,
  textColor,
  backgroundColor,
  mobilePresentation,
  buttonText,
  buttonStyling,
  newWindow,
  iconImage,
  url,
  description
}) {
  const parsedDocument = Array.isArray(document) ? { pageable: { items: document } } : { document };
  function getModels() {
    return {
      ...parsedDocument,
      coverImage,
      html,
      visibility,
      iframe: {
        source,
        height,
        scrolling,
        title
      }
    };
  }
  function getParameters() {
    return {
      anchorId,
      template,
      videoUrl,
      expandedByDefault,
      recommendedProducts,
      imageWidth,
      imageAlignment,
      bannerWidth,
      bannerHeight,
      tooltip,
      showCountdown,
      endDate,
      countdownText,
      layout,
      textColor,
      backgroundColor,
      mobilePresentation,
      buttonText,
      buttonStyling,
      newWindow,
      iconImage,
      url,
      description
    };
  }
  return { getModels, getParameters };
}
export {
  ContentBlock,
  blockMap,
  ContentBlock as default
};
//# sourceMappingURL=ContentBlock.js.map
